import React, { useEffect, useRef } from "react";
import PublicUserInfo from "./PublicUserInfo";
import PublicUserMessage from "./PublicUserMessage";
import PublicUserPhoto from "./PublicUserPhoto";
import PublicUserPayment from "./PublicUserPayment";
import PublicUserReport from "./PublicUserReport";
import { useDispatch, useSelector } from "react-redux";
import { publicUserActions, authActions, masterActions, eCardAction } from "../../_store";
import { UserRoleType, MenuItem } from "../../_helpers/enumerator";
import { showToastNotification } from "../../components/common/ui/NotificationModal/ToastNotication.js";
import { history } from "../../_helpers";
import dragicon from "../../assets/svg/click-and-drag.svg";
import PublicUserEcard from "./PublicUserEcard.jsx";

function PublicUserAccordion() {
  const { PublicUserCurrentTab } = useSelector((x) => x?.publicUser);
  const dispatch = useDispatch();
  const { user, userAccessibleMenuInfo, commonFacilityCode } = useSelector(
    (x) => x.auth
  );

  // Hide or show reports tab
  const shouldShowReportsTab = [
    UserRoleType.SuperAdmin,
    UserRoleType.FacilitySuperAdmin,
    UserRoleType.InvestigatorsStaff,
  ].includes(user.UserRoleID);

  // Hide or show Payment tab
  const shouldShowPaymentTab = [
    UserRoleType.SuperAdmin,
    UserRoleType.FacilitySuperAdmin,
  ].includes(user.UserRoleID);

  // Hide or Show Message Tab
  const shouldShowMessageTab =
    Array.isArray(userAccessibleMenuInfo) && userAccessibleMenuInfo.length > 0
      ? userAccessibleMenuInfo.some(
        (item) =>
          item?.ManagementMenuID === MenuItem.MessagesMenuItem &&
          item?.MenuActiveStatus === 1
      )
      : true;
  // Hide or Show Photo Tab
  const shouldShowPhotoTab =
    Array.isArray(userAccessibleMenuInfo) && userAccessibleMenuInfo.length > 0
      ? userAccessibleMenuInfo.some(
        (item) =>
          item?.ManagementMenuID === MenuItem.PhotosMenuItem &&
          item?.MenuActiveStatus === 1
      )
      : true;

  const shouldShowEcardTab =
    Array.isArray(userAccessibleMenuInfo) && userAccessibleMenuInfo.length > 0
      ? userAccessibleMenuInfo.some(
        (item) =>
          item?.ManagementMenuID === MenuItem.EcardsMenuItem &&
          item?.MenuActiveStatus === 1
      )
      : true;

  // Get User Accessible Menu Info
  useEffect(() => {
    dispatch(authActions.GetUserAccessibleMenuInfo(user.ManagementUserID));
  }, [dispatch]);

  // Load facility dropdown on component mount
  const prevFacilityCodeRef = useRef(commonFacilityCode);

  useEffect(() => {
    if (prevFacilityCodeRef.current !== commonFacilityCode) {
      history.navigate("PublicUserList");
    }
  }, [commonFacilityCode]);

  useEffect(() => {
    dispatch(
      masterActions.LoadFacilityDropDown({
        facilityID: 0,
      })
    );
  }, []);

  const GetUserAccessibleMenuInfo = (tabId) => {
    dispatch(publicUserActions.setPublicUserTab(tabId));
    dispatch(authActions.GetUserAccessibleMenuInfo(user.ManagementUserID)).then(
      (res) => {
        // Hide or Show Message Tab btn
        const shouldShowMessage =
          Array.isArray(res?.payload) && res?.payload.length > 0
            ? res?.payload.some(
              (item) =>
                item?.ManagementMenuID === MenuItem.MessagesMenuItem &&
                item?.MenuActiveStatus === 1
            )
            : true;

        // Hide or Show Photo Tab
        const shouldShowPhoto =
          Array.isArray(res?.payload) && res?.payload.length > 0
            ? res?.payload.some(
              (item) =>
                item?.ManagementMenuID === MenuItem.PhotosMenuItem &&
                item?.MenuActiveStatus === 1
            )
            : true;
        if (!shouldShowMessage && !shouldShowPhoto) {
          dispatch(publicUserActions.setPublicUserTab("publicuser-info-tab"));
          showToastNotification(
            "The Message and Photo menus have been disabled by the admin.",
            "error"
          );
        } else if (!shouldShowMessage && tabId === "publicuser-message-tab") {
          dispatch(publicUserActions.setPublicUserTab("publicuser-info-tab"));
          showToastNotification(
            "The Message menu has been disabled by the admin.",
            "error"
          );
        } else if (!shouldShowPhoto && tabId === "publicuser-photos-tab") {
          dispatch(publicUserActions.setPublicUserTab("publicuser-info-tab"));
          showToastNotification(
            "The Photo menu has been disabled by the admin.",
            "error"
          );
        } else {
          dispatch(publicUserActions.setPublicUserTab(tabId));
        }
      }
    );
  };

  return (
    <div className="card shadow-sm b-r-all p-4 border border-dark-grey mt-3 w-100 mb-4">
      <div className="overflow-auto">
        <ul
          className="nav nav-tabs tab-bg d-flex flex-nowrap overflow-auto"
          style={{ whiteSpace: "nowrap" }}
        >
          {/* <ul className="nav nav-tabs tab-bg"> */}
          <li className="nav-item flex-shrink-0">
            <a
              href="#publicuser-info-tab"
              data-bs-toggle="tab"
              className={`nav-link ${PublicUserCurrentTab === "publicuser-info-tab"
                ? "active"
                : "text-black"
                }`}
              onClick={() =>
                dispatch(
                  publicUserActions.setPublicUserTab("publicuser-info-tab")
                )
              }
            >
              <span className=" font-size-15 ">
                <i className="fa fa-info-circle"></i> Info
              </span>
            </a>
          </li>
          {shouldShowMessageTab && (
            <li className="nav-item flex-shrink-0">
              <a
                href="#publicuser-message-tab"
                data-bs-toggle="tab"
                className={`nav-link ${PublicUserCurrentTab === "publicuser-message-tab"
                  ? "active"
                  : "text-black"
                  }`}
                onClick={() => {
                  GetUserAccessibleMenuInfo("publicuser-message-tab");
                  dispatch(publicUserActions.resetpuInitialMessageSearch())
                }}
              >
                <span className=" font-size-15 ">
                  <i className="fa fa-commenting"></i> Messages
                </span>
              </a>
            </li>
          )}
          {shouldShowPhotoTab && (
            <li className="nav-item flex-shrink-0">
              <a
                href="#publicuser-photos-tab"
                data-bs-toggle="tab"
                className={`nav-link ${PublicUserCurrentTab === "publicuser-photos-tab"
                  ? "active"
                  : "text-black"
                  }`}
                onClick={() => {
                  GetUserAccessibleMenuInfo("publicuser-photos-tab");
                  dispatch(publicUserActions?.resetPuInitialPhotosSearch());
                }}
              >
                <span className=" font-size-15 ">
                  <i className="fa fa-camera"></i> Photos
                </span>
              </a>
            </li>
          )}
          {shouldShowEcardTab && (
            <li className="nav-item flex-shrink-0">
              <a
                href="#publicuser-ecard-tab"
                data-bs-toggle="tab"
                className={`nav-link ${PublicUserCurrentTab === "publicuser-ecard-tab"
                  ? "active"
                  : "text-black"
                  }`}
                onClick={() => {
                  GetUserAccessibleMenuInfo("publicuser-ecard-tab");
                  dispatch(eCardAction.resetSentEcardSearch())
                }
                }
              >
                <span className=" font-size-15 ">
                  <i className="fa fa-envelope"></i> E-Cards
                </span>
              </a>
            </li>
          )}
          {shouldShowPaymentTab && (
            <li className="nav-item flex-shrink-0">
              <a
                href="#publicuser-payments-tab"
                data-bs-toggle="tab"
                className={`nav-link ${PublicUserCurrentTab === "publicuser-payments-tab"
                  ? "active"
                  : "text-black"
                  }`}
                onClick={() =>
                  dispatch(
                    publicUserActions.setPublicUserTab(
                      "publicuser-payments-tab"
                    )
                  )
                }
              >
                <span className=" font-size-15 ">
                  <i className="fa-brands fa-cc-paypal"></i> Payments
                </span>
              </a>
            </li>
          )}
          {shouldShowReportsTab && (
            <li className="nav-item flex-shrink-0">
              <a
                href="#publicuser-reports-tab"
                data-bs-toggle="tab"
                className={`nav-link ${PublicUserCurrentTab === "publicuser-reports-tab"
                  ? "active"
                  : "text-black"
                  }`}
                onClick={() =>
                  dispatch(
                    publicUserActions.setPublicUserTab("publicuser-reports-tab")
                  )
                }
              >
                <span className=" font-size-15 ">
                  <i className="fa fa-reorder"></i> Reports
                </span>
              </a>
            </li>
          )}
        </ul>
        <div className="dragicon-container">
          <img
            src={dragicon}
            alt="pending-status"
            title="Pending"
            className="dragicon"
          />
        </div>
        <div className="tab-content panel rounded-0 m-0">
          <div
            className={`tab-pane fade ${PublicUserCurrentTab === "publicuser-info-tab"
              ? "active show"
              : "text-black"
              }`}
            id="publicuser-info-tab"
          >
            {PublicUserCurrentTab === "publicuser-info-tab" && (
              <PublicUserInfo />
            )}
          </div>
          {shouldShowMessageTab && (
            <div
              className={`tab-pane fade ${PublicUserCurrentTab === "publicuser-message-tab"
                ? "active show"
                : "text-black"
                }`}
              id="publicuser-message-tab"
            >
              {PublicUserCurrentTab === "publicuser-message-tab" && (
                <PublicUserMessage />
              )}
            </div>
          )}
          {shouldShowPhotoTab && (
            <div
              className={`tab-pane fade ${PublicUserCurrentTab === "publicuser-photos-tab"
                ? "active show"
                : "text-black"
                }`}
              id="publicuser-photos-tab"
            >
              {PublicUserCurrentTab === "publicuser-photos-tab" && (
                <PublicUserPhoto />
              )}
            </div>
          )}
          {shouldShowEcardTab && (
            <div
              className={`tab-pane fade ${PublicUserCurrentTab === "publicuser-ecard-tab"
                ? "active show"
                : "text-black"
                }`}
              id="publicuser-ecard-tab"
            >
              {PublicUserCurrentTab === "publicuser-ecard-tab" && (
                <PublicUserEcard />
              )}
            </div>
          )}
          {shouldShowPaymentTab && (
            <div
              className={`tab-pane fade ${PublicUserCurrentTab === "publicuser-payments-tab"
                ? "active show"
                : "text-black"
                }`}
              id="publicuser-payments-tab"
            >
              {PublicUserCurrentTab === "publicuser-payments-tab" && (
                <PublicUserPayment />
              )}
            </div>
          )}
          {shouldShowReportsTab && (
            <div
              className={`tab-pane fade ${PublicUserCurrentTab === "publicuser-reports-tab"
                ? "active show"
                : "text-black"
                }`}
              id="publicuser-reports-tab"
            >
              {PublicUserCurrentTab === "publicuser-reports-tab" && (
                <PublicUserReport />
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default React.memo(PublicUserAccordion);
